import Resource from "nvent-web/services/resources/Resource";
import { DetailedRoom } from "nvent-web/types/DetailedRoom";

export default class RoomsResource extends Resource {
  getOne(projectId: number, roomId: number) {
    return this.http.get<DetailedRoom>(`/admin/projects/${projectId}/rooms/${roomId}`);
  }
}
